import React from "react";
import { Box, Modal, StylesProvider } from "@material-ui/core";
import "./ModalContext.css";
import { X } from "react-feather";
import Slide from "@material-ui/core/Slide";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
var useStyles = makeStyles(function () { return ({
    boxBackground: {
        background: "#F7FAFC",
    },
}); });
export var ModalOverlay = function (props) {
    var _a, _b, _c, _d;
    var classes = useStyles();
    var isTabModal = props.tabButton ? true : false;
    var modalCoverClassName = "modal-cover " + (isTabModal ? "modal-cover-tab" : "");
    return (React.createElement("div", null,
        isTabModal && !props.openModal && (React.createElement("div", { className: "button-floating" },
            React.createElement(Button, { variant: "contained", color: "primary", style: (_a = props.tabButton) === null || _a === void 0 ? void 0 : _a.style, size: "medium", className: "button-vertical button-tap-fixed", onClick: props.onOpenModal },
                React.createElement("span", { className: "vertical-text" }, (_b = props.tabButton) === null || _b === void 0 ? void 0 : _b.text)))),
        React.createElement(StylesProvider, { injectFirst: true },
            React.createElement(Modal, { open: props.openModal, onClose: props.onCloseModal, "aria-labelledby": "simple-modal-title", "aria-describedby": "simple-modal-description", className: "modal-main-container", BackdropProps: { invisible: !props.overlay }, hideBackdrop: props.backdrop, disableAutoFocus: true, disableEnforceFocus: true },
                React.createElement(Slide, { direction: props.transition, timeout: 340, in: props.openModal, mountOnEnter: true, unmountOnExit: true },
                    React.createElement("div", { className: modalCoverClassName },
                        isTabModal && (React.createElement(Button, { variant: "contained", color: "primary", style: (_c = props.tabButton) === null || _c === void 0 ? void 0 : _c.style, className: "button-vertical button-tap", onClick: props.onCloseModal },
                            React.createElement("span", { className: "vertical-text" }, (_d = props.tabButton) === null || _d === void 0 ? void 0 : _d.text))),
                        React.createElement("div", { className: "modal-close-icon", onClick: props.onCloseModal },
                            React.createElement(X, { size: 20 })),
                        React.createElement("div", null, props.header),
                        React.createElement("div", { className: "modal-context-body" }, props.body),
                        props.footer ? (props.footer) : (React.createElement("div", { className: classes.boxBackground },
                            React.createElement(Box, { marginBottom: 1 })))))))));
};
